/**
 * @type {{ translation: ITranslationObject }}
 */
const en = {
  translation: {
    FIELDS: {
      REQUIRED: 'required field',
      REQUIRED_EMPTY: 'Required field not filled',
      INVALID_INPUT: 'The entered value is invalid.',
      WITHOUT_MASK: 'No mask',
      PHONE_TYPE_COMERCIAL: 'Business',
      PHONE_TYPE_CELLPHONE: 'Cellphone',
      PHONE_TYPE_RESIDENTIAL: 'Residential',
      PHONE_TYPE_FAX: 'Fax',
      PHONE_TYPE_OTHERS: 'Others',
      INPUT_WITHOUT_OPTIONS: 'No options match your search.',
      FILE_MAX_SIZE_ALLOWED: 'Maximum allowed file size: {{size}}',
      FILE_TOO_BIG_WARN: 'The file {{item}} is bigger than {{size}}',
      CHOOSE_FILE: 'Choose file',
      MASK_ERROR: 'Check if the field has been filled out according to the selected mask.',
      MASK_DROPDOWN: {
        MASK_IMG_BRA_ALT: 'Brazil flag',
        MASK_IMG_USA_ALT: 'United States flag',
        MASK_IMG_MEX_ALT: 'Mexico flag',
        MASK_IMG_ARG_ALT: 'Argentina flag',
        MASK_IMG_CHL_ALT: 'Chile flag',
        MASK_IMG_URY_ALT: 'Uruguay flag',
        MASK_IMG_COL_ALT: 'Colombia flag',
        MASK_IMG_PER_ALT: 'Peru flag',
        MASK_IMG_NONE_ALT: 'No flag',
      },
    },
    GENERICS: {
      TOASTER: {
        FORM_ERROR: 'Error while submitting the form',
        FORM_SUCCESS: 'Form sent successfully',
      },
      LOADING: {
        SENDING_DATA: 'Sending data...',
        DONT_RELOAD_PAGE: 'Please do not refresh the page until the operation is complete.'
      },
      SENDING_FORM: 'Sending form',
      EXTERNAL_FORM_TITLE: 'External form | Powered by Nagro',
      SEND: 'Send',
      HOUR: 'Hour',
      FORM_NOT_FOUND: 'A form could not be found'
    },
  },
};

export default en;
